import { Typography } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { useIntl } from "react-intl";
import { useCongress } from "../../hooks";

const CountDown = () => {
  const intl = useIntl();

  const { congress } = useCongress();

  return (
    <Typography variant="body1">
      <strong>
        {intl.formatMessage({
          id: "Auth.CountDown.Greetings",
          defaultMessage: "Thank you for registering"
        })}
        .&nbsp;
      </strong>
      {intl.formatMessage(
        {
          id: "Auth.CountDown.CountDown",
          defaultMessage:
            "You’ll receive an e-mail when the event website will be available {name} will start in"
        },
        congress
      )}
      <strong>&nbsp;{moment(congress.startAt).fromNow()}.</strong>
    </Typography>
  );
};

export default CountDown;
